import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/svg/videoplay.svg'


const _withScopeId = n => (_pushScopeId("data-v-c7909ba8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "jumbotron" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-12 col-md-8 infotext" }
const _hoisted_5 = { class: "text" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, [
    /*#__PURE__*/_createElementVNode("h1", null, "Scrape websites without limits")
  ])
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, "Up to 50 000 datacenter proxies"),
  /*#__PURE__*/_createElementVNode("li", null, "99% uptime guarantee"),
  /*#__PURE__*/_createElementVNode("li", null, "Unlimited bandwidth")
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-lg-5 col-12" }, [
  /*#__PURE__*/_createElementVNode("a", {
    class: "btn w-100",
    href: "/premium?ref=home"
  }, "Start now")
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  style: {"width":"20px","margin-right":"5px"},
  alt: ""
}, null, -1))
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Welcome video ")
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]

import { computed } from 'vue';
import { useStore } from 'vuex';
import VideoModal from './VideoModal.vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore();

const isVideoModal = computed(() => store.getters.isVideoModalStatus);

const playVideo = () => store.commit('SET_VIDEO_PLAYER');

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _hoisted_7,
            _createElementVNode("div", { class: "row" }, [
              _hoisted_8,
              _createElementVNode("div", { class: "col-lg-5 col-12" }, [
                _createElementVNode("button", {
                  id: "playvideo",
                  class: "lets-play btn-outline-jum w-100",
                  "data-video": "https://vimeo.com/644945961",
                  style: {"background-color":"unset","display":"flex","justify-content":"center"},
                  onClick: playVideo
                }, _hoisted_11)
              ])
            ]),
            _withDirectives(_createVNode(VideoModal, null, null, 512), [
              [_vShow, _unref(isVideoModal)]
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})